import { Component, ViewChild } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';
import { ResidentSoldReservationFiltersComponent } from './resident-sold-reservation-filters/resident-sold-reservation-filters.component';

@Component({
	selector: 'app-resident-sold-reservation',
	templateUrl: './resident-sold-reservation.component.html',
	styleUrls: ['./resident-sold-reservation.component.css'],
})
export class ResidentSoldReservationComponent extends ListComponent {
	@ViewChild(ResidentSoldReservationFiltersComponent)
	ResidentSoldReservationFiltersComponent: ResidentSoldReservationFiltersComponent;
	protected itemsBeforeDataLoad = 2;
	protected apiUrl = 'resident/reservationTrip';
	filters;
	parameters = {
		users: null,
	};
	sum = {
		euro: null,
		hr: null,
		soldTrips: null,
	};
	tableRows = [
		{ id: 'reservationNumber', name: 'Numer rezerwacji' },
		{ id: 'created', name: 'Data sprzedaży' },
		{ id: 'name', name: 'Nazwa wycieczki' },
		{ id: 'priceEUR', name: 'Cena EUR' },
		{ id: 'priceHR', name: 'Cena HR' },
		{ id: 'isZero', name: 'Uwagi' },
		{ id: 'createdBy_name', name: 'Sprzedane przez' },
	];

	protected loadBefore() {
		this.api.get('/users/', (result, error) => {
			this.parameters.users = result.data;
			this.loadData();
		});
	}

	calculationPrice(filtredElements) {
		this.sum.euro = 0;
		this.sum.hr = 0;
		this.sum.soldTrips = 0;
		filtredElements.map((obj) => {
			this.sum.euro += parseFloat(obj.priceEUR);
			this.sum.hr += parseFloat(obj.priceHR);
			this.sum.soldTrips += 1;
		});
	}

	protected convertData(data) {
		data.forEach((obj) => {
			obj.isZero = obj.isZero == '1' ? 'Wycieczka zakupiona w biurze/rekompensata |' : '';
			obj.isZero += obj.status == 'C' ? ' Rezerwacja anulowana' : '';
			const createdBy = this.parameters.users.find((objfind) => objfind.id == obj.createdBy);
			obj.createdBy_name = obj.createdBy ? createdBy.name : '';
		});
		return data;
	}
}
